const LIMITATIONS = {
  ADDITIONAL_OCCUPANTS_LIMIT: 10,
  ONE_TIME_FEES_LIMIT: 5,
  PETS_LIMIT: 10,
  KEYS_LIMIT: 10,
};

module.exports = LIMITATIONS;
